


























































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import CardInputResep from "@/components/pemeriksaan/CardInputResep.vue";
import CardListResep from "./resep-obat/CardListResep.vue";
import { resepStore } from "@/store/modules/resep";
import { appModule } from "@/store/modules/app";
import http from "@/axios/http-common";
import { userModule } from "@/store/modules/user";
import PaketObatList from "./resep-obat/lembar-permintaan/PaketObat/PaketObatList.vue";
import AntimikrobaReserveList from "./resep-obat/lembar-permintaan/AntimikrobaReserve/AntimikrobaReserveList.vue";
import OrderEmergensiList from "./resep-obat/order-emergensi/OrderEmergensiList.vue";

@Component({
  components: {
    CardInputResep,
    CardListResep,
    PaketObatList,
    AntimikrobaReserveList,
    OrderEmergensiList,
  },
  inject: {
    isReadOnly: { default: () => () => false },
  },
})
export default class TabResepObat extends Vue {
  dataExample = "";
  listResep = [];
  activeResep = {};
  timeout = 2000;
  innerTab = "sub-resep-bmhp";
  focusOrderEmergensiId: number | null = null;

  @Prop() register: number;

  @Prop() rm: number;

  @Prop({ default: null }) deepLink!: any;

  @Watch("deepLink", { immediate: true })
  onDeepLink(payload: any) {
    if (!payload || payload.topTab !== "tab-resep" || !payload.elemId) {
      return;
    }
    this.$nextTick(() => {
      this.innerTab = payload.elemId;
    });
  }

  isReadOnly!: () => boolean;

  get readOnly(): boolean {
    return this.isReadOnly();
  }

  mounted() {
    this.getResepList(this.register).then(() => {
      const userResep = resepStore.resep.filter((resep) => {
        return resep.dokter.id == userModule.user.id && !resep.order_emergensi_id;
      });

      if (userResep.length) {
        this.setActiveResep(userResep[userResep.length - 1]);
      }
    });
  }

  get bisaBukaResume(): boolean {
    return this.stateuser.profesi === "Dokter";
  }

  /**
   * Resume Rawat Jalan adalah halaman biasa di tab Suket, bukan modal — tombol
   * ini memindahkan halaman ke sana lewat deep-link universal dan membentangkan
   * form-nya langsung.
   */
  bukaHalamanResume() {
    this.$emit("pageTabResume", {
      topTab: "tab-suket",
      elemId: "tab-resume",
      category: "Resume & Rawat",
      bukaForm: true
    });
  }

  get stateuser() {
    return userModule.user;
  }

  get loading() {
    return appModule.loading;
  }

  get mode() {
    return appModule.mode;
  }

  get snackbar() {
    return appModule.snackbar;
  }

  get notice() {
    return appModule.notice;
  }

  updateResepList() {
    this.getResepList(this.register);
  }

  setActiveResep(val) {
    this.activeResep = val;
  }

  getResepList(reg) {
    resepStore.SET_LIST_LOADING(true);

    return http
      .getData(`/register/${reg}/resep-obat-text`)
      .then((response) => {
        resepStore.setResep(response.data.data);
        // console.log("aaa:", response.data.data);
      })
      .then(() => {
        resepStore.SET_LIST_LOADING(false);
      });
  }

  addResep() {
    this.activeResep = {};
    resepStore.showInputResep();
  }

  bukaOrderEmergensi(orderId: number) {
    this.innerTab = "sub-order-emergensi";
    this.focusOrderEmergensiId = null;
    this.$nextTick(() => {
      this.focusOrderEmergensiId = orderId;
    });
  }
}
